<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <div class="o-section__text" v-if="active">
        <div ref="textA" data-scene="8a">
          <div v-for="line in copy.top" v-html="line" :key="line"></div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="active">
        <figure class="o-section__figure" ref="figureA" data-scene="8a">
          <Img :src="require('@/assets/scene8/spread8_a.png')" filename="spread8_a" />
        </figure>

        <figure class="o-section__figure" ref="figureB" data-scene="8b">
          <Img :src="require('@/assets/scene8/spread8_b.png')" filename="spread8_b" />
        </figure>

        <figure class="o-section__figure anim-scene-8" ref="figureB2" data-scene="8b2">
          <Img :src="require('@/assets/scene8/spread8_b2.png')" filename="spread8_b2" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import Img from '@/components/Img'

export default {
  name: 'Scene8',
  props: ['options', 'active', 'copy', 'disableBlur'],

  mounted () {
    this.$root.$on('startScene8', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureB, this.$refs.figureB2],
        translateX: ['-80px', '0'],
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB2.querySelector('div'),
        scale: [
          { value: [0, 1], duration: this.options.durationLarge, delay: 0, easing: 'cubicBezier(0.010, 0.975, 0.400, 1.005)' }
        ],
        translateY: [
          { value: ['0', '300px'], duration: this.options.durationLarge, delay: 0, easing: 'cubicBezier(0.805, 0.020, 1.000, 0.770)' }
        ],
        duration: this.options.durationLarge,
        loop: true
      })

      this.$anime({
        targets: this.$refs.figureA,
        translateX: ['100px', '0'],
        delay: 150,
        duration: this.options.durationLarge,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureA,
          opacity: [0, 1],
          delay: 150,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureA,
          filter: ['blur(5px)', 'blur(0px)'],
          delay: 150,
          duration: this.options.durationRegular,
          easing: this.options.easing
        })
      }
    }
  },

  components: {
    Img
  }
}
</script>
